import { Component, OnInit, OnDestroy, NgZone, AfterViewInit } from '@angular/core';
import { IAgoraRTCRemoteUser, IAgoraRTCClient, ICameraVideoTrack, IMicrophoneAudioTrack, ILocalVideoTrack, AREAS } from "agora-rtc-sdk-ng";
import AgoraRTC from "agora-rtc-sdk-ng";
import { ApiService } from '../../api.service';
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from './../../../environments/environment';
declare var $: any;
import Swal from 'sweetalert2';
import VirtualBackgroundExtension from "agora-extension-virtual-background";
import { Howl, Howler } from 'howler';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
/* import { Firestore, collection, collectionData, query, where, collectionChanges, DocumentChange, orderBy, writeBatch, doc, getDocs } from '@angular/fire/firestore'; */
import { AgoraRtmService } from '../../agora-rtm.service';

@Component({
	selector: 'app-video-call',
	templateUrl: './video-call.component.html',
	styleUrl: './video-call.component.scss'
})
export class VideoCallComponent implements OnInit, OnDestroy, AfterViewInit {
	remoteCalls: any[] = [];
	localStreams: any = [];
	currentVideo: any = null;

	videoClient!: IAgoraRTCClient;
	screenClient!: IAgoraRTCClient;
	localStream!: ICameraVideoTrack;
	localAudioStream!: IMicrophoneAudioTrack;
	shareStream!: ILocalVideoTrack;

	token: any = null;
	chat_token: any = null;
	channelName: any = null;
	userId!: number;
	screenUserId!: number;
	/* otherSideUserId!: number;
	otherSideScreenUserId!: number; */
	userName: string = "";
	joinStatus = { isJoined: false };
	isMute = false;
	isVideoMute = false;
	agoraAppId = environment.agoraAppID;
	cameraVideoProfile = '480_4';
	screenVideoProfile = '480_2';
	msg = '';
	messages: any[] = [];
	peers: string[] = [];
	private subs: Subscription[] = [];
	fileUploaderLoader = false;
	public files: NgxFileDropEntry[] = [];
	errorLog: any = null;
	errorLogs = false;
	numbers = [
		{ num: 1, color: "#28a745" },
		{ num: 2, color: "#28a745" },
		{ num: 3, color: "#007bff" },
		{ num: 4, color: "#007bff" },
		{ num: 5, color: "#ffc107" },
		{ num: 6, color: "#ffc107" },
		{ num: 7, color: "#ff5707" },
		{ num: 8, color: "#ff5707" },
		{ num: 9, color: "#dc3545" },
		{ num: 10, color: "#dc3545" }
	];
	numberOfPidsToColor: number = 0;
	intervalMicListen: any = null;
	playAlertRing = new Howl({
		src: ['../../../assets/files/sound1.mp3']
	});
	playAlertNotify = new Howl({
		src: ['../../../assets/files/sound2.mp3']
	});
	isPopupOpen = false;
	audioDevices: any[] = [];
	videoDevices: any[] = [];
	selectedMicrophoneId: any = null;
	selectedCameraId: any = null;
	doctor_avatar = "../../../assets/img/PSYCHOLOGIST.png";
	remoteUsers: any[] = [];
	isPanelOpen = true;
	videoHeight = 200;
	videoWidth = "100%";
	labelHeight = 22;
	mainVideoHeight: number = window.innerHeight - 130;
	extension = new VirtualBackgroundExtension();
	processor: any = null;
	virtualBackgroundEnabled: string = "";
	backgroundProp: string = "#00ff00";
	bgColors = [
		"#00008B",
		"#808080",
		"#FBFAF5",
		"#475c6c",
		"#eed7a1",
		"#f7efd2"
	];
	bgImages = [
		"../../../assets/img/bg1.jpeg",
		"../../../assets/img/bg2.jpg",
		"../../../assets/img/bg3.jpg",
		"../../../assets/img/bg4.jpg",
		"../../../assets/img/bg5.jpg",
		"../../../assets/img/bg6.jpg"
	];
	uId: any = null;
	followId: any = null;
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	pageLoading1 = false;
	followUpDetails: any = null;
	user: any = null;
	constructor(private agora: AgoraRtmService, private toastr: ToastrService, private apiService: ApiService, private activeRoute: ActivatedRoute) { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["caseId"];
			this.followId = routeParams["followId"];
			this.userId = parseInt(routeParams["userId"]);
			try {
				this.uId = decodeURIComponent(this.uId);
			} catch (e) { }
			try {
				this.followId = decodeURIComponent(this.followId);
			} catch (e) { }
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/" + this.followId, name: "Appointment Details", queryparams: { "follow-up": this.followId } });
			this.breadcrumbList.push({ path: "/app/followup-report/" + this.uId + "/" + this.followId, name: "Video Call" });
			this.apiService.userData$.subscribe((user: any) => {
				if (user) {
					this.user = user;
					this.getDetails();
				}
			})
		});
	}

	ngOnDestroy(): void {
		try {
			this.clearBackground();
		} catch (error) { }
		if (this.joinStatus.isJoined == true) {
			try {
				this.leave();
			} catch (error) {

			}
		} else {
			try {
				this.stopTestCamera();
			} catch (error) {

			}
		}
	}

	ngAfterViewInit(): void {
		this.closeNav();
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getFollowupDetails(this.followId).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.followUpDetails = data.data;
				this.channelName = this.followUpDetails.case_id.id.toString();
				/* this.userId = this.user.id; */
				this.screenUserId = this.userId + 1;
				/* this.otherSideUserId = this.followUpDetails.case_id.candidate.id;
				this.otherSideScreenUserId = this.otherSideUserId + 1; */
				this.userName = `${this.user.first_name} ${this.user.last_name}`;
				this.setupVars();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	openBackgroundModal() {
		$("#backgroundModal").modal("show");
	}

	setBackgroundProperty(prop: string, virtualBackgroundEnabled: string) {
		this.backgroundProp = prop;
		this.virtualBackgroundEnabled = virtualBackgroundEnabled;
		this.setBackground();
		$("#backgroundModal").modal("hide");
	}

	async getProcessorInstance() {
		try {
			this.localStream.unpipe();
			this.processor.unpipe();
			this.processor = null;
		} catch (error) { }
		if (!this.processor && this.localStream) {
			this.processor = this.extension.createProcessor();
			try {
				await this.processor.init("./assets/wasms");
			} catch (e) {
				return null;
			}
			this.localStream.pipe(this.processor).pipe(this.localStream.processorDestination);
		}
		return this.processor;
	}

	setBackground() {
		if (this.virtualBackgroundEnabled == "color") {
			this.setBackgroundColor();
		} else if (this.virtualBackgroundEnabled == "blur") {
			this.setBackgroundBlurring();
		} else if (this.virtualBackgroundEnabled == "img") {
			this.setBackgroundImage();
		} else if (this.virtualBackgroundEnabled == "") {
			this.clearBackground();
		}
	}

	clearBackground() {
		try {
			this.localStream.unpipe();
			this.processor.unpipe();
			this.processor = null;
		} catch (error) { }
	}

	async setBackgroundColor() {
		if (this.localStream) {
			await this.getProcessorInstance();
			try {
				this.processor.setOptions({ type: 'color', color: this.backgroundProp });
				await this.processor.enable();
			} finally { }
			this.virtualBackgroundEnabled = "color";
		}
	}

	async setBackgroundBlurring() {
		if (this.localStream) {
			await this.getProcessorInstance();
			try {
				this.processor.setOptions({ type: 'blur', blurDegree: 3 });
				await this.processor.enable();
			} finally { }
			this.virtualBackgroundEnabled = "blur";
		}
	}

	async setBackgroundImage() {
		const imgElement = document.createElement('img');
		imgElement.onload = async () => {
			await this.getProcessorInstance();
			try {
				this.processor.setOptions({ type: 'img', source: imgElement });
				await this.processor.enable();
			} finally { }

			this.virtualBackgroundEnabled = "img";
		}
		imgElement.src = this.backgroundProp;
	}

	toggleNav() {
		try {
			this.isPanelOpen = !this.isPanelOpen;
			if (this.isPanelOpen) {
				document.getElementById("myMenuPanel")!.style.width = "20%";
				document.getElementById("myDiagramPanel")!.style.width = "80%";
			} else {
				document.getElementById("myMenuPanel")!.style.width = "0";
				document.getElementById("myDiagramPanel")!.style.width = "100%";
			}
			setTimeout(() => {
				this.playMain();
			}, 1000);
		} catch (error) { }
	}

	openNav() {
		try {
			this.isPanelOpen = true;
			document.getElementById("myMenuPanel")!.style.width = "20%";
			document.getElementById("myDiagramPanel")!.style.width = "80%";
			setTimeout(() => {
				this.playMain();
			}, 1000);
		} catch (error) { }
	}

	closeNav() {
		try {
			this.isPanelOpen = false;
			document.getElementById("myMenuPanel")!.style.width = "0";
			document.getElementById("myDiagramPanel")!.style.width = "100%";
			setTimeout(() => {
				this.playMain();
			}, 1000);
		} catch (error) { }
	}

	getDevices() {
		AgoraRTC.getDevices(false).then(devices => {
			for (let i = 0; i < devices.length; i++) {
				if (devices[i].kind == "audioinput") {
					this.audioDevices.push(devices[i]);
				} else if (devices[i].kind == "videoinput") {
					this.videoDevices.push(devices[i]);
				}
			}
			this.selectedMicrophoneId = this.audioDevices[0].deviceId;
			this.selectedCameraId = this.videoDevices[0].deviceId;
			this.testCamera();
		}).catch(e => {
			this.toastr.error("Unable to access microphone/camera.", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	testCamera() {
		let width = $("#test_stream").width();
		let height = Math.round((width * 3) / 4);
		$("#test_stream").height(height);
		AgoraRTC.createMicrophoneAndCameraTracks({ microphoneId: this.selectedMicrophoneId }, { cameraId: this.selectedCameraId }).then((tracks) => {
			$("#test_stream").html("");
			this.localStream = tracks[1];
			this.localAudioStream = tracks[0];
			if ($("#test_stream").length) {
				this.localStream.play("test_stream");
				this.intervalMicListen = setInterval(() => {
					this.colorPids();
				}, 100);
			}
		}, (error: any) => {
			this.toastr.error("Unable to access microphone/camera.", 'Error', {
				tapToDismiss: true,
				closeButton: true,
				timeOut: 3000
			});
		});
	}

	stopTestCamera() {
		if (this.localStream) {
			this.localStream.stop();
			this.localStream.close();
		}
		if (this.localAudioStream) {
			this.localAudioStream.stop();
			this.localAudioStream.close();
		}
		clearInterval(this.intervalMicListen);
		this.numberOfPidsToColor = 0;
	}

	changeMicOrCamera() {
		this.stopTestCamera();
		setTimeout(() => {
			this.testCamera();
		}, 1000);
	}

	testSpeaker() {
		this.playAlertRing.play();
	}

	colorPids() {
		var vol: any = this.localAudioStream!.getVolumeLevel() * 100;
		this.numberOfPidsToColor = Math.round(vol / 10);
	}

	setupVars() {
		AgoraRTC.registerExtensions([this.extension]);
		this.getDevices();
		this.apiService.getAgoraToken(this.userId, this.channelName).subscribe({
			next: (data: any) => {
				this.token = data["rtc_token"];
				this.chat_token = data["rtm_token"];
			}, error: (error) => {
				this.toastr.error("Unable to initiate call.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	openForm() {
		document.getElementById("myForm")!.style.display = "block";
		$("#videoChatButton").removeClass("shake");
	};

	closeForm() {
		document.getElementById("myForm")!.style.display = "none";
	}

	sendMsg(photoURL: any, dataText: any) {
		if (dataText == null || dataText == "") {
			return;
		}
		if (!dataText.trim()) {
			return;
		}
		let msgObj = {
			channel: this.channelName,
			imageUrl: photoURL,
			message: dataText,
			msgTime: new Date(),
			senderScreenName: this.userName,
			isRead: false
		};
		this.agora.sendChannelMessage(dataText.trim()).then(
			(val: any) => {
				console.log(val);
				this.msg = '';
			}, (error) => {
				console.log(error);
			}
		);

		/* this.messagingService.sendMessageInVideoCall(msgObj).then((done) => {
			this.msg.data = null;
		}).catch((err) => {
			this.toastr.error("Unable to send", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}) */
	}

	openFileMang() {
		$("#chatFileModal").modal("show");
	}

	initJoinCall() {
		this.openNav();
		try {
			this.stopTestCamera();
		} catch (error) { }
		this.videoClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'h264' });
		this.assignClientHandlers();
		this.videoClient.join(environment.agoraAppID, this.channelName, this.token, this.userId).then((uId) => {
			this.localStreams.push(uId);
			AgoraRTC.createMicrophoneAndCameraTracks({ microphoneId: this.selectedMicrophoneId }, { cameraId: this.selectedCameraId }).then((tracks) => {
				$("#agora_local").html("");
				this.localStream = tracks[1];
				this.localAudioStream = tracks[0];
				this.localStream.play("agora_local");
				this.setBackground();
				this.videoClient.publish(tracks).then((success) => { }, (error) => { });
				this.joinSuccess();
			}, (error: any) => {
				this.toastr.error("Unable to access microphone/camera.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			});
		});
	}

	async joinSuccess() {
		this.joinStatus.isJoined = true;
		this.apiService.sendCallJoinStatus(this.joinStatus.isJoined);
		await this.agora.init(environment.agoraAppID);
		await this.agora.login(this.userId.toString(), this.chat_token);
		await this.agora.joinChannel(this.channelName);

		this.subs.push(this.agora.messages$.subscribe(m => this.messages = m));
		this.subs.push(this.agora.peers$.subscribe(p => this.peers = p));
	}

	async shareScreen() {
		if (this.screenClient != undefined && this.screenClient != null) {
			try {
				this.shareStream.stop();
				this.shareStream.close();
				await this.screenClient.leave();
			} catch (error) { }
			this.initShareScreen();
		} else {
			this.initShareScreen();
		}
	}

	initShareScreen() {
		this.apiService.getAgoraToken(this.screenUserId, this.channelName).subscribe({
			next: (data: any) => {
				this.screenClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
				this.screenClient.join(environment.agoraAppID, this.channelName, data["rtc_token"], this.screenUserId).then((uId) => {
					this.localStreams.push(uId);
					AgoraRTC.createScreenVideoTrack({ encoderConfig: "1080p_1" }, "disable").then((track) => {
						this.shareStream = track;
						this.screenClient.publish(track).then((success) => { }, (error) => {
							try {
								this.screenClient.leave();
							} catch (error) { }
							this.toastr.error("Unable to share screen.", 'Error', {
								tapToDismiss: true,
								closeButton: true,
								timeOut: 3000
							});
						});
					}, (error: any) => {
						try {
							this.screenClient.leave();
						} catch (error) { }
						this.toastr.error("Unable to share screen.", 'Error', {
							tapToDismiss: true,
							closeButton: true,
							timeOut: 3000
						});
					});
				});
			}, error: (error) => {
				this.toastr.error("Unable to share screen.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	assignClientHandlers(): void {
		this.videoClient.on("token-privilege-will-expire", (user: any) => {
			this.renewToken();
		});

		this.videoClient.on("token-privilege-did-expire", (user: any) => {
			this.renewToken();
		});

		this.videoClient.on("user-published", (user: IAgoraRTCRemoteUser, mediaType: any) => {
			var uid: any = user.uid;
			if (!this.localStreams.includes(uid)) {
				this.subscribeRemoteUser(user, mediaType);
			}
		});

		this.videoClient.on("user-unpublished", (user: IAgoraRTCRemoteUser) => {
			var uid: any = user.uid;
			if (!user.videoTrack && !user.audioTrack) {
				this.remoteCalls = this.remoteCalls.filter(call => call.user.uid != uid);
				this.refreshRemoteVideos();
				this.getUserCount();
			} else if (!user.videoTrack) {
				$("#" + uid).css("background-color", "#000");
			}
		});

		this.videoClient.on("user-left", (user: IAgoraRTCRemoteUser) => {
			var uid: any = user.uid;
			this.remoteCalls = this.remoteCalls.filter(call => call.user.uid != uid);
			this.refreshRemoteVideos();
			this.getUserCount();
		});
	}

	getUserCount() {
		this.remoteUsers = this.videoClient.remoteUsers;
	}

	refreshRemoteVideos() {
		if (this.currentVideo) {
			try {
				let found = false;
				for (let i = 0; i < this.remoteCalls.length; i++) {
					if (this.remoteCalls[i].user.uid == this.currentVideo.user.uid) {
						this.currentVideo = this.remoteCalls[i];
						found = true;
					}
				}
				if (found) {
					setTimeout(() => {
						this.playMain();
					}, 1000);
				} else {
					this.currentVideo = null;
				}
			} catch (error) { }
		} else {
			this.currentVideo = null;
		}
		for (let i = 0; i < this.remoteCalls.length; i++) {
			if (this.showDiv(this.remoteCalls[i].user.uid)) {
				setTimeout(() => {
					this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
					this.remoteCalls[i].user.audioTrack?.play();
				}, 1000);
			}
		}
	}

	async subscribeRemoteUser(user: IAgoraRTCRemoteUser, mediaType: any) {
		await this.videoClient.subscribe(user, mediaType);
		let uid = user.uid;
		this.remoteCalls = this.remoteCalls.filter(call => call.user.uid != uid);
		/* if (uid == this.otherSideUserId.toString()) {
			this.remoteCalls.push({ uname: this.candName, user: user });
		} else if (uid == this.otherSideScreenUserId.toString()) {
			this.remoteCalls.push({ uname: this.candName + "_Screen", user: user });
		} else {
			this.remoteCalls.push({ uname: this.userName, user: user });
		} */
		if (uid != this.userId.toString() && uid != this.screenUserId.toString()) {
			this.remoteCalls.push({ uname: uid, user: user });
		} else {
			this.remoteCalls.push({ uname: this.userName, user: user });
		}
		this.refreshRemoteVideos();
		this.getUserCount();
	}

	renewToken() {
		this.apiService.getAgoraToken(this.userId, this.channelName).subscribe({
			next: (data: any) => {
				this.token = data["rtc_token"];
				this.videoClient.renewToken(this.token);
			}, error: (error) => {
				this.toastr.error("Unable to continue the call.", 'Error', {
					tapToDismiss: true,
					closeButton: true,
					timeOut: 3000
				});
			}
		});
	}

	async leave() {
		this.closeNav();
		try {
			this.localStream.stop();
			this.localStream.close();
			this.localAudioStream.stop();
			this.localAudioStream.close();
		} catch (error) { }
		this.joinStatus.isJoined = false;
		this.apiService.sendCallJoinStatus(this.joinStatus.isJoined);
		this.remoteCalls = [];
		if (this.videoClient != undefined) {
			await this.videoClient.leave();
		}
		if (this.screenClient != undefined) {
			try {
				this.shareStream.stop();
				this.shareStream.close();
			} catch (error) { }
			await this.screenClient.leave();
		}
		try {
			this.subs.forEach(s => s.unsubscribe());
			this.agora.leaveChannel();
			this.agora.logout();
		} catch (error) { }
		this.isMute = false;
		this.isVideoMute = false;
	}

	toggleMute() {
		if (this.isMute) {
			this.localAudioStream.setMuted(false);
		} else {
			this.localAudioStream.setMuted(true);
		}
		this.isMute = !this.isMute;
	}

	toggleMuteVideo() {
		if (this.isVideoMute) {
			this.setBackground();
			this.localStream.setMuted(false);
		} else {
			this.localStream.setMuted(true);
			this.clearBackground();
		}
		this.isVideoMute = !this.isVideoMute;
	}

	highlightStream(index: number) {
		this.currentVideo = null;
		this.currentVideo = this.remoteCalls[index];
		for (let i = 0; i < this.remoteCalls.length; i++) {
			if (this.showDiv(this.remoteCalls[i].user.uid)) {
				setTimeout(() => {
					this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
					this.remoteCalls[i].user.audioTrack?.play();
				}, 1000);
			}
		}
		setTimeout(() => {
			this.playMain();
		}, 1000);
	}

	playMain() {
		try {
			let divWidth = $("#" + this.currentVideo.user.uid.toString()).width();
			let videoWidth = this.currentVideo.user.videoTrack._videoWidth;
			let videoHeight = this.currentVideo.user.videoTrack._videoHeight;
			let divHeight = videoHeight * divWidth / videoWidth;
			$("#" + this.currentVideo.user.uid.toString()).height(divHeight);

			this.currentVideo.user.videoTrack?.play(this.currentVideo.user.uid.toString());
			this.currentVideo.user.audioTrack?.play();
		} catch (error) { }
	}

	clipText(text: String, length: number) {
		return text.slice(0, length);
	}

	minimizeMain() {
		this.currentVideo = null;
		for (let i = 0; i < this.remoteCalls.length; i++) {
			setTimeout(() => {
				this.remoteCalls[i].user.videoTrack?.play(this.remoteCalls[i].user.uid.toString());
				this.remoteCalls[i].user.audioTrack?.play();
			}, 1000);
		}
	}

	showDiv(uid: any) {
		try {
			if (uid == this.currentVideo.user.uid) {
				return false;
			} else {
				return true;
			}
		} catch (error) {
			return true;
		}
	}

	public caseFilesUpload(files: NgxFileDropEntry[]) {
		this.files = files;
		/* for (const droppedFile of files) {
			if (droppedFile.fileEntry.isFile) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.fileUploaderLoader = true;
					let fileName = file.name;
					this.apiService.fileUpload(fileName, environment.CHAT_FILE_UPLOAD_DESTINATION).subscribe({
						next: (data: any) => {
							this.fileUploaderLoader = false;
							this.fileUploaderLoader = true;
							this.apiService.uploadFileToS3(file, data[0].presigned_url).subscribe({
								next: res => {
									this.fileUploaderLoader = false;
									const chatFileData = {
										"id": this.channelNameEncoded,
										"filename": data[0].file_name,
										"file": data[0].file_url
									}
									this.fileUploaderLoader = true;
									this.apiService.chatFileUpload(chatFileData).subscribe({
										next: (res1: any) => {
											this.fileUploaderLoader = false;
											this.sendMsg(data[0].file_url, data[0].orig_name);
											$("#chatFileModal").modal("hide");
										}, error: (error: any) => {
											this.fileUploaderLoader = false;
											this.toastr.error("Unable to upload.", 'Error', {
												timeOut: 3000,
												tapToDismiss: true,
												closeButton: true
											});
										}
									});
								}, error: (error) => {
									this.fileUploaderLoader = false;
									this.toastr.error("Something went wrong.", 'Error', {
										tapToDismiss: true,
										closeButton: true,
										timeOut: 3000
									});
								}
							});
						}, error: (error) => {
							this.fileUploaderLoader = false;
							this.toastr.error("Something went wrong.", 'Error', {
								tapToDismiss: true,
								closeButton: true,
								timeOut: 3000
							});
						}
					});
				});
			} else {
				this.errorLog = "Invalid File Format.";
				this.errorLogs = true;
				setTimeout(() => {
					this.errorLogs = false;
				}, 10000);
				this.toastr.error("Invalid File Format.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		} */
	}

	validURL(str: any) {
		var pattern = new RegExp('^(https?:\\/\\/)?' +
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
			'((\\d{1,3}\\.){3}\\d{1,3}))' +
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
			'(\\?[;&a-z\\d%_.~+=-]*)?' +
			'(\\#[-a-z\\d_]*)?$', 'i');
		return !!pattern.test(str);
	}

	keyDownFunction(event: any) {
		if (event.keyCode === 13) {
			this.sendMsg('', this.msg);
		}
	}
}
